import { render, staticRenderFns } from "./AppOffersList.vue?vue&type=template&id=1da1c80f&scoped=true"
import script from "./AppOffersList.vue?vue&type=script&lang=ts"
export * from "./AppOffersList.vue?vue&type=script&lang=ts"
import style0 from "./AppOffersList.vue?vue&type=style&index=0&id=1da1c80f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1c80f",
  null
  
)

export default component.exports